// extracted by mini-css-extract-plugin
module.exports = {"primary":"#694361","secondary":"#EDEDED","accent":"#395453","muted":"#456E6C","error":"#D16565","success":"#33A08E","base":"#3C3333"};